import { useState, useContext } from "react";
import { useFetchModule } from "../../hooks/firestore/useFetchModule";
import { useSiteWideSale } from "../../hooks/firestore/useSiteWideSale";
import { AuthContext } from "../../context/AuthContext";

import styles from "./QrButton.module.css";

export default function QrButton({ moduleId }) {
  const [showQr, setShowQr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { saleData } = useSiteWideSale();

  const { moduleData } = useFetchModule(moduleId);
  const { user } = useContext(AuthContext);

  const BANK_ID = "TCB"; // Techcombank
  const ACCOUNT_NO = "19032905704011"; //
  const TEMPLATE = "print"; // or 'compact', 'compact2, 'qr_only
  const ACCOUNT_NAME = "Nguyen Trong Hoan";

  // Amount and Description will be added dynamically
  const baseAmount = moduleData?.listed_fee?.amount;
  const hasAmountField = moduleData?.listed_fee?.hasOwnProperty("amount");
  const isValidAmount =
    hasAmountField && typeof baseAmount === "number" && baseAmount > 0;

  // Calculate final amount with site-wide sale if applicable
  let AMOUNT = baseAmount;
  let isSaleApplied = false;
  if (
    isValidAmount &&
    saleData.site_wide_sale_enabled &&
    saleData.site_wide_sale_percent > 0 &&
    saleData.site_wide_sale_until &&
    new Date() < saleData.site_wide_sale_until
  ) {
    const discountMultiplier = 1 - saleData.site_wide_sale_percent / 100;
    AMOUNT = Math.round(baseAmount * discountMultiplier);
    isSaleApplied = true;
  }

  const userEmail = user?.email || "NoEmail";
  // Replace special characters that VietQR API strips away
  let sanitizedEmail = userEmail.replace(/[@.]/g, " ");
  // Remove "gmailcom" if it's a gmail.com address
  if (userEmail.endsWith("gmail.com")) {
    sanitizedEmail = sanitizedEmail.replace(/ gmail com$/, "");
  }
  const userId = user?.uid ? user.uid.substring(0, 6) : "NoUser";

  // Description typically includes user email and module ID
  const DESC = encodeURIComponent(`${sanitizedEmail} ${moduleId} ${userId}`);

  const qrUrl = `https://img.vietqr.io/image/${BANK_ID}-${ACCOUNT_NO}-${TEMPLATE}.png?amount=${AMOUNT}&addInfo=${DESC}&accountName=${ACCOUNT_NAME}`;

  const handleShowQr = () => {
    if (!moduleId || !isValidAmount) return;
    setShowQr(!showQr);
    if (!showQr) {
      setIsLoading(true);
      setHasError(false);
    }
  };

  if (!moduleId) {
    return <div className={styles.error}>Error: Module ID is required</div>;
  }

  if (!isValidAmount) {
    if (!hasAmountField) {
      return (
        <div className={styles.error}>Error: Payment amount not configured</div>
      );
    }
    if (baseAmount === 0) {
      return <div className={styles.error}>Error: Payment amount is zero</div>;
    }
    return <div className={styles.error}>Error: Invalid payment amount</div>;
  }

  return (
    <div style={{ textAlign: "center" }}>
      {!(showQr && isLoading) && (
        <button className={styles.button} onClick={handleShowQr}>
          {showQr ? "Ẩn mã QR" : "🤳 Hiện mã QR thanh toán"}
        </button>
      )}
      {showQr && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          {isLoading && <p>⏳ Đang lấy mã QR... chờ xíu nhe 🙂‍↕️</p>}
          {hasError && <p style={{ color: "red" }}>💀 Gặp lỗi khi lấy mã QR</p>}
          {isSaleApplied && !isLoading && !hasError && (
            <p
              style={{
                color: "#faff68ff",
                fontWeight: "bold",
                fontSize: "20px",
                margin: "10px 0",
                textTransform: "uppercase",
              }}
            >
              🎉 Mã giảm {saleData.site_wide_sale_percent}% đã được áp dụng! 🎉
            </p>
          )}
          <img
            src={qrUrl}
            alt={`QR Code for ${moduleId}`}
            width={"320px"}
            onLoad={() => setIsLoading(false)}
            onError={() => {
              setIsLoading(false);
              setHasError(true);
            }}
            style={{ display: isLoading ? "none" : "block" }}
          />
          {isSaleApplied && !isLoading && !hasError && (
            <p
              style={{
                color: "#4aff47ff",
                fontWeight: "bold",
                fontSize: "18px",
                margin: "10px 0",
                textTransform: "uppercase",
              }}
            >
              Chương trình khuyến mãi sẽ <br /> kết thúc{" "}
              {saleData.site_wide_sale_until.toLocaleTimeString()}, ngày{" "}
              {saleData.site_wide_sale_until.toLocaleDateString()}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
